module.exports = __webpack_public_path__ + "media/common/images/badges/active/s_plynem_na_podlaze-1032d7fd2aa35a48bd373923beb35b9d.svg";